// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
}

.input {
  position: relative;
}
.input .label {
  margin-bottom: 6px;
  line-height: 41px;
}
.input .description {
  margin-bottom: 15px;
}
.input .placeholder {
  text-transform: uppercase;
  letter-spacing: 0.24px;
  margin-bottom: 4px;
}
.input label {
  position: absolute;
  width: 100%;
  padding: 9.5px 14px 0;
  font-family: var(--ion-font-family);
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  pointer-events: none;
  transition: padding 0.2s, color 0.2s, font-size 0.2s;
}
.input label.format {
  padding: 18.5px 14px 17.5px;
  font-size: 16px;
  line-height: 19px;
}
.input .input-clone-right {
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  border: 0;
  position: absolute;
  right: 0;
  bottom: 16px;
}
.input input {
  width: 100%;
  height: 48px;
  padding: 18.5px 14px 17.5px;
  border: 1px solid var(--ion-color-border);
  background: var(--ion-color-white);
  border-radius: var(--border-radius);
  font-family: var(--ion-font-family);
  color: var(--ion-color-dark);
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  -webkit-appearance: none;
  outline: unset;
}
.input input.no-floated-label {
  height: 48px;
}
.input input:focus {
  border-color: var(--ion-color-primary);
}
.input input::placeholder {
  padding: 0;
}
.input.focus label {
  color: var(--ion-color-primary);
}
.input.focus input {
  padding: 24.5px 14px 11.5px;
}
.input.focus input.no-floated-label {
  padding: 18.5px 14px 17.5px;
}
.input.focus.hint input {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.input.with-value input {
  padding: 24.5px 14px 11.5px;
}
.input.with-value input.no-floated-label {
  padding: 18.5px 14px 17.5px;
}
.input.error label {
  color: var(--ion-color-danger);
}
.input.error input {
  border-color: var(--ion-color-danger);
}
.input .info-container {
  border: 1px solid var(--ion-color-primary);
  background: var(--ion-color-light);
  padding: 5px 14px;
  border-top: none !important;
  border-radius: var(--border-radius);
}

.checkbox {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  min-height: 55px;
  border-radius: 8px;
  background: var(--ion-color-background);
  padding: 17px 13px;
  border: 1px solid transparent;
}
.checkbox .first {
  display: flex;
  align-items: flex-start;
}
.checkbox .link {
  margin-left: 13px;
}
.checkbox.checked {
  border: 1px solid var(--ion-color-primary);
}
.checkbox ion-checkbox {
  --border-radius: 3px;
  --size: 22px;
  min-width: 22px;
  --checkmark-width: 3px;
  margin: 0;
  margin-right: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/input/input/input.component.scss","webpack://./src/app/components/input/input-checkbox/input-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;ACCF;;ADEA;EACE,kBAAA;ACCF;ADCE;EACI,kBAAA;EACA,iBAAA;ACCN;ADEE;EACI,mBAAA;ACAN;ADGE;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;ACDJ;ADIE;EACI,kBAAA;EAEA,WAAA;EACA,qBAAA;EAGA,mCAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EAEA,oBAAA;EACA,oDAAA;ACNN;ADQM;EACI,2BAAA;EAEA,eAAA;EACA,iBAAA;ACPV;ADWE;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;ACTN;ADYE;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,yCAAA;EACA,kCAAA;EACA,mCAAA;EAGA,mCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;ACZN;ADcM;EACI,YAAA;ACZV;ADeM;EACI,sCAAA;ACbV;ADgBM;EAEI,UAAA;ACfV;ADoBM;EACI,+BAAA;AClBV;ADqBM;EACI,2BAAA;ACnBV;ADqBU;EACI,2BAAA;ACnBd;ADwBU;EACI,4BAAA;EACA,6BAAA;ACtBd;AD4BM;EACI,2BAAA;AC1BV;AD4BU;EACI,2BAAA;AC1Bd;ADgCM;EACI,8BAAA;AC9BV;ADiCM;EACI,qCAAA;AC/BV;ADmCE;EACI,0CAAA;EACA,kCAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;ACjCN;;AAjGA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,6BAAA;AAoGF;AAlGE;EACE,aAAA;EACA,uBAAA;AAoGJ;AAjGE;EACE,iBAAA;AAmGJ;AAhGE;EACE,0CAAA;AAkGJ;AA/FE;EACE,oBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AAiGJ","sourcesContent":[":host {\n  display: inline-block;\n}\n\n.input {\n  position: relative;\n\n  .label {\n      margin-bottom: 6px;\n      line-height: 41px;\n  }\n\n  .description {\n      margin-bottom: 15px;\n  }\n\n  .placeholder {\n    text-transform: uppercase;\n    letter-spacing: .24px;\n    margin-bottom: 4px;\n  }\n\n  label {\n      position: absolute;\n\n      width: 100%;\n      padding: 9.5px 14px 0;\n\n      // color: var(--ion-color-low-emphasis);\n      font-family: var(--ion-font-family);\n      font-weight: normal;\n      font-size: 12px;\n      line-height: 12px;\n\n      pointer-events: none;\n      transition: padding .2s, color .2s, font-size .2s;\n\n      &.format {\n          padding: 18.5px 14px 17.5px;\n          // color: var(--ion-color-low-emphasis);\n          font-size: 16px;\n          line-height: 19px;\n      }\n  }\n\n  .input-clone-right {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: auto;\n      border: 0;\n      position: absolute;\n      right: 0;\n      bottom: 16px;\n  }\n\n  input {\n      width: 100%;\n      height: 48px;\n      padding: 18.5px 14px 17.5px;\n      border: 1px solid var(--ion-color-border);\n      background: var(--ion-color-white);\n      border-radius: var(--border-radius);\n\n      // color: var(--ion-color-high-emphasis-light);\n      font-family: var(--ion-font-family);\n      color: var(--ion-color-dark);\n      font-weight: normal;\n      font-size: 16px;\n      line-height: 22px;\n      -webkit-appearance: none;\n      outline: unset;\n\n      &.no-floated-label{\n          height: 48px;\n      }\n\n      &:focus {\n          border-color: var(--ion-color-primary);\n      }\n\n      &::placeholder {\n          // color: var(--ion-color-low-emphasis);\n          padding: 0;\n      }\n  }\n\n  &.focus {\n      label {\n          color: var(--ion-color-primary);\n      }\n\n      input {\n          padding: 24.5px 14px 11.5px;\n\n          &.no-floated-label{\n              padding: 18.5px 14px 17.5px;\n          }\n      }\n\n      &.hint {\n          input {\n              border-bottom-left-radius: 0;\n              border-bottom-right-radius: 0;\n          }\n      }\n  }\n\n  &.with-value {\n      input {\n          padding: 24.5px 14px 11.5px;\n\n          &.no-floated-label{\n              padding: 18.5px 14px 17.5px;\n          }\n      }\n  }\n\n  &.error {\n      label {\n          color: var(--ion-color-danger);\n      }\n\n      input {\n          border-color: var(--ion-color-danger);\n      }\n  }\n\n  .info-container {\n      border: 1px solid var(--ion-color-primary);\n      background: var(--ion-color-light);\n      padding: 5px 14px;\n      border-top: none !important;\n      border-radius: var(--border-radius);\n  }\n}\n","@import \"../input/input.component.scss\";\n\n\n.checkbox {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 55px;\n  border-radius: 8px;\n  background: var(--ion-color-background);\n  padding: 17px 13px;\n  border: 1px solid transparent;\n\n  .first {\n    display: flex;\n    align-items: flex-start;\n  }\n\n  .link {\n    margin-left: 13px;\n  }\n\n  &.checked {\n    border: 1px solid var(--ion-color-primary);\n  }\n\n  ion-checkbox {\n    --border-radius: 3px;\n    --size: 22px;\n    min-width: 22px;\n    --checkmark-width: 3px;\n    margin: 0;\n    margin-right: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
